import { executeRequest, JFSRequest } from '@jfs/network'
import { returnBankListMappedData } from './../data/parser/screen/SelectedBankListById'
import { RootStore } from './../data/store'
import { parseLinkedBanks } from './../network/parsers/UserParser'
import { getAPIBody } from './ApiBody/getUserAccountDetailsBody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigWithAuthCred } from './config'

const responseParser = (data: any, bankId: any) => {
  const selectedBank = returnBankListMappedData(bankId)
  const parsedBanks = parseLinkedBanks(data, selectedBank)
  return parsedBanks
}

const returnHeader = () => {
  return {
    'Content-Type': 'application/json',
    Authorization: RootStore.user.session.userAccessToken,
  }
}

const getUserAccountDetails = (bankId: string, mobile: string) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.banksByMobileNo,
    method: 'POST',
    config: sitConfigWithAuthCred(RootStore.user.session.getTokens, mobile),
    body: getAPIBody(bankId),
    headers: returnHeader(),
  }

  return executeRequest(request).then((data) => {
    return responseParser(data, bankId)
  })
}

export { getUserAccountDetails }
